
<div class="setTable" style="margin-top: 10px;">
    <ng-container *ngIf="!hideCharges">
        <!-- nested table delete on 10-06-2025 -->
        <!--        <mat-table [dataSource]="bookingChargesList" multiTemplateDataRows class="lightSleekTable">
                  <ng-container matColumnDef="expand">
                      <mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;
                      </mat-header-cell>
                      <mat-cell *matCellDef="let element">
                          <button mat-icon-button aria-label="expand row"--
                                  (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation
                              <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down
                              </mat-icon>
                              <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up
                              </mat-icon>
                          </button>
                      </mat-cell>
                  </ng-container>
                  <ng-container [matColumnDef]="'charge_description'">
                      <mat-header-cell *matHeaderCellDef> Charge</mat-header-cell>
                      <mat-cell *matCellDef="let data" class="fs-12 ">
                          <div style="display: flex; flex-direction: column; align-items:
                                                              flex-start;">
                                                                  <span class="natureChip">
                                                                      {{ data.charge_description }}
                                                                  </span>
                          </div>
                      </mat-cell>
                  </ng-container>
                  <ng-container [matColumnDef]="'charge_type'">
                      <mat-header-cell *matHeaderCellDef> Basis</mat-header-cell>
                      <mat-cell *matCellDef="let data" class="fs-12 ">
                          <span>
                                                                  {{ data.charge_type == 'container' ? 'Container' : 'Job' }}
                                                              </span>
                      </mat-cell>
                  </ng-container>
                  <ng-container [matColumnDef]="'quantity'">
                      <mat-header-cell *matHeaderCellDef> Quantity</mat-header-cell>
                      <mat-cell *matCellDef="let data" class="fs-12 ">
                          <span>
                                                                  {{ data.quantity }}
                                                              </span>
                      </mat-cell>
                  </ng-container>
                  <ng-container [matColumnDef]="'total_amount'">
                      <mat-header-cell *matHeaderCellDef> Total</mat-header-cell>
                      <mat-cell *matCellDef="let data" class="fs-12 ">
                          <span>
                                                                  {{ data.total_amount | number: '1.2-2' }} {{ data.currency }}
                                                              </span>
                      </mat-cell>
                  </ng-container>
                  <ng-container [matColumnDef]="'invoice_status'">
                      <mat-header-cell *matHeaderCellDef> Status</mat-header-cell>
                      <mat-cell *matCellDef="let data" class="fs-12 ">
                          <mat-chip [style.background-color]="'blue'"--
                                    style="color:white
                              {{ data?.invoice_status == null ? "-" : data?.invoice_status }}
                          </mat-chip>
                      </mat-cell>
                  </ng-container>
                  <ng-container [matColumnDef]="'created_at'">
                      <mat-header-cell *matHeaderCellDef> Created On</mat-header-cell>
                      <mat-cell *matCellDef="let data" class="fs-12 ">
                          <span>
                              {{ data?.created_at == null ? "-" : (data?.created_at | date: 'dd MMM, yyyy') }}
                          </span>
                      </mat-cell>
                  </ng-container>
                  <ng-container matColumnDef="expandedDetail">
                      <mat-cell *matCellDef="let element"--
                                [attr.colspan]="chargeColumnsWithExpand.length
                          <div class="example-element-detail"--
                               [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed
                              <div class="example-element-description">
                                  <mat-table [dataSource]="element.requirement_charges">
                                      <ng-container [matColumnDef]="'action'">
                                          <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
                                          <mat-cell *matCellDef="let data" class="fs-12 ">
                                              <div class="actions">
                                                  <i class="flaticon-view" (click)="viewContainers(data)"></i>
                                              </div>
                                          </mat-cell>
                                      </ng-container>
                                      <ng-container [matColumnDef]="'charge_description'">
                                          <mat-header-cell *matHeaderCellDef> Charge</mat-header-cell>
                                          <mat-cell *matCellDef="let data" class="fs-12 ">
                                              <div style="display: flex; flex-direction: column; align-items:
                                                              flex-start;">
                                                                  <span class="natureChip">
                                                                      {{ data.charge_description }}
                                                                  </span>
                                              </div>
                                          </mat-cell>
                                      </ng-container>
                                      <ng-container [matColumnDef]="'quantity'">
                                          <mat-header-cell *matHeaderCellDef> Quantity</mat-header-cell>
                                          <mat-cell *matCellDef="let data" class="fs-12 ">
                                              <span>
                                                                  {{ data.quantity }}
                                                              </span>
                                          </mat-cell>
                                      </ng-container>
                                      <ng-container [matColumnDef]="'total_amount'">
                                          <mat-header-cell *matHeaderCellDef> Total</mat-header-cell>
                                          <mat-cell *matCellDef="let data" class="fs-12 ">
                                              <span>
                                                                  {{ data.total_amount | number: '1.2-2' }} {{ data.currency }}
                                                              </span>
                                          </mat-cell>
                                      </ng-container>
                                      <ng-container [matColumnDef]="'invoice_status'">
                                          <mat-header-cell *matHeaderCellDef> Status</mat-header-cell>
                                          <mat-cell *matCellDef="let data" class="fs-12 ">
                                              <mat-chip [style.background-color]="'blue'"--
                                                        style="color:white
                                                  {{ data?.invoice_status == null ? "-" : data?.invoice_status }}
                                              </mat-chip>
                                          </mat-cell>
                                      </ng-container>
                                      <ng-container [matColumnDef]="'created_at'">
                                          <mat-header-cell *matHeaderCellDef> Created On</mat-header-cell>
                                          <mat-cell *matCellDef="let data" class="fs-12 ">
                                              <span>
                                                  {{ data?.created_at == null ? "-" : (data?.created_at | date: 'dd MMM, yyyy') }}
                                              </span>
                                          </mat-cell>
                                      </ng-container>
                                      <mat-header-row--
                                          *matHeaderRowDef="chargeChildColumns ; sticky: true "></mat-header-row>
                                      <mat-row *matRowDef="let row; columns: chargeChildColumns;"--
                                               [hidden]="element.requirement_charges.length == 0"></mat-row>
                                  </mat-table>
                              </div>
                          </div>
                      </mat-cell>
                  </ng-container>
                  <mat-header-row *matHeaderRowDef="chargeColumnsWithExpand"></mat-header-row>
                  <mat-row *matRowDef="let element; columns: chargeColumnsWithExpand;"--
                           class="example-element-row
                           [class.example-expanded-row]="expandedElement === element
                           (click)="expandedElement = expandedElement === element ? null : element
                  </mat-row>
                  <mat-row *matRowDef="let row; columns: ['expandedDetail']"--
                           class="example-detail-row"></mat-row>
              </mat-table>
              <ng-container *ngIf="!bookingChargesList?.data?.length">
                  <div class="noData" (mousemove)="onMouseMove($event)">
                      <h1 #title>No Data Found</h1>
                  </div>
              </ng-container>
              <mat-paginator [pageSizeOptions]="[5, 10, 25]" aria-label="Select page of users"--
                             [pageSize]="10
                             [length]="pageLength" (page)="pageChanged($event
                             #paginator></mat-paginator>-->
        <div class="btnb" style="display: flex;
        justify-content: space-between;
        margin-top: 5px; margin-bottom: 10px;">
            <div *ngIf="rtype == 'one_way' || rtype == 'lease'" fxLayout="row" fxFlex="50"
                 class=" align-items-center gap-2">
                <span>To Date : </span>
                <app-date-field [isEditable]="true"
                                [(ngModel)]="rentalToDate"
                                [maxDate]="currentDate"
                                fxFlex="13em"
                                [name]="'rentalToDate'">
                </app-date-field>
                <button mat-raised-button (click)="fetchRentalDetails()" class="addBtn clickIt"
                        matTooltipPosition="above"
                        matTooltip="Fetch Rental details and Send to Arthakosh "> Fetch Rental Details
                </button>
            </div>
            <div style="display: flex; gap: 10px; flex-direction: row;">
                <button mat-raised-button  class="addBtn" (click)="invoiceParty($event)" *ngIf="requestDetails?.requestor.company?.total_branch_count>1">
                    Update Invoice Party
                </button>
                <button mat-raised-button *ngIf="showGenerateInvoice"
                        (click)="generateInvoice()" class="addBtn">
                    Generate Invoice
                </button>
                <button mat-raised-button *ngIf="chargesDataSource.data.length == 0 && !hideAddCharge"
                        (click)="addNewCharge()" class="addBtn">
                    Add New Charge
                </button>
            </div>
        </div>
        <mat-table [dataSource]="reqirementChargesDataSource" class="lightSleekTable" style="max-height: 350px;
                                        overflow-y: auto;">
            <ng-container [matColumnDef]="'charge_description'">
                <mat-header-cell *matHeaderCellDef> Charge</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                    <div style="display: flex; flex-direction: column; align-items:
                                                        flex-start;">
                        <span class="natureChip" style="display: flex; flex-direction: column">
                            <span>
                                {{ data.charge_description }}
                            </span>
                            <ng-container *ngIf="(data.lowestStartDate != '' &&
                                data.lowestStartDate != null && data.highestEndDate != '' &&
                                data.highestEndDate != null)">
                                <span style="font-size: 10px; color: #f05f25;" *ngIf="data.lowestStartDate != '' &&
                                data.lowestStartDate != null">
                                    From: {{ data.lowestStartDate != null ? (data.lowestStartDate | date:'dd MMM, yyyy') : '-' }}
                                </span>
                                <span style="font-size: 10px; color: #f05f25;" *ngIf="data.highestEndDate != '' &&
                                data.highestEndDate != null">
                                    To: {{ data.highestEndDate != null ? (data.highestEndDate| date:'dd MMM, yyyy') : '-' }}
                                </span>
                            </ng-container>
                        </span>

                    </div>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'requirement'">
                <mat-header-cell *matHeaderCellDef> Requirement</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                    <div style="display: flex; flex-direction: column; align-items:
                                                        flex-start;">
                        <span class="natureChip">
                            {{ data.particulars }}
                        </span>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'quantity'">
                <mat-header-cell *matHeaderCellDef> Quantity</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                    <span (click)="data.charge_type != 'job' ? showContainers(data) : ''"
                          [matTooltip]="data.charge_type != 'job' ? 'View list of containers' :
                          ''" [style]="data.charge_type != 'job' ?
                          'color: #f05f25; text-decoration: underline; cursor: pointer;' :
                          'color: grey; cursor: not-allowed;'">
                           {{ data.quantity }}
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'amount_per_unit'">
                <mat-header-cell *matHeaderCellDef> Amount/Unit</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 overflow-visible" [class.p-r-15]="data.edit">
                    <span *ngIf="!data.edit">
                        {{ data.amount_per_unit | number: '1.2-2' }} {{ data.currency }}
                    </span>
                    <app-new-money-field class="w-100 bookingChargeMoneyField" [isEditable]="true" [minValue]="0"
                                         [(amount)]="data.amount_per_unit"
                                         [(currency)]="data.currency" *ngIf="data.edit"
                                         (amountChange)="setTotalUpdate(data)">
                    </app-new-money-field>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'total_amount'">
                <mat-header-cell *matHeaderCellDef> Total</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                    <span>
                        {{ data.total_amount | number: '1.2-2' }} {{ data.currency }}
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'invoice_status'">
                <mat-header-cell *matHeaderCellDef> Invoice Status</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                    <mat-chip [style.background-color]="getBackgroundColor(data?.invoice_status)"
                              style="color:white">
                        {{ data?.invoice_status == null ? "-" : data?.invoice_status }}
                    </mat-chip>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'created_at'">
                <mat-header-cell *matHeaderCellDef> Created On</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                                        <span>
                                            {{ data?.created_at == null ? "-" : (data?.created_at | date: 'dd MMM, yyyy') }}
                                        </span>
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="'action'" *ngIf="!requestService.selectedRequest.is_booking_closed">
                <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
                <mat-cell *matCellDef="let data" class="fs-12 ">
                    <button *ngIf="!data.edit && showActions && data?.invoice_status != 'Invoiced'" mat-menu-item
                            (click)="updateAmount(data)">
                        <div class="moreActions">
                            <i class="flaticon-pencil"></i>
                            <!--                            <span> Edit Charge</span>-->
                        </div>
                    </button>
                    <button *ngIf="data.edit && showActions && data?.invoice_status != 'Invoiced'" mat-menu-item
                            (click)="saveRequirement(data)">
                        <div class="moreActions">
                            <i class="flaticon-save"></i>
                            <!--                            <span> Save Charge</span>-->
                        </div>
                    </button>
                    <!--                    <button mat-icon-button [matMenuTriggerFor]="menuAction"-->
                    <!--                            aria-label="Action Menu">-->
                    <!--                        <mat-icon>more_vert</mat-icon>-->
                    <!--                    </button>-->
                    <!--                    <mat-menu #menuAction="matMenu">-->
                    <!--                        &lt;!&ndash;                        <button mat-menu-item (click)="showContainers(data)">&ndash;&gt;-->
                    <!--                        &lt;!&ndash;                            <div class="moreActions">&ndash;&gt;-->
                    <!--                        &lt;!&ndash;                                <i class="flaticon-view"></i>&ndash;&gt;-->
                    <!--                        &lt;!&ndash;                                <span> View list of containers</span>&ndash;&gt;-->
                    <!--                        &lt;!&ndash;                            </div>&ndash;&gt;-->
                    <!--                        &lt;!&ndash;                        </button>&ndash;&gt;-->
                    <!--                        <button *ngIf="!data.edit && showActions && data?.invoice_status != 'Invoiced'" mat-menu-item-->
                    <!--                                (click)="updateAmount(data)">-->
                    <!--                            <div class="moreActions">-->
                    <!--                                <i class="flaticon-pencil"></i>-->
                    <!--                                <span> Edit Charge</span>-->
                    <!--                            </div>-->
                    <!--                        </button>-->
                    <!--                        &lt;!&ndash;                        <button *ngIf="!data.edit && showActions && data?.invoice_status != 'Invoiced'" mat-menu-item&ndash;&gt;-->
                    <!--                        &lt;!&ndash;                                (click)="deleteRequirement(data)">&ndash;&gt;-->
                    <!--                        &lt;!&ndash;                            <div class="moreActions">&ndash;&gt;-->
                    <!--                        &lt;!&ndash;                                <i class="flaticon-delete"></i>&ndash;&gt;-->
                    <!--                        &lt;!&ndash;                                <span> Delete Charge</span>&ndash;&gt;-->
                    <!--                        &lt;!&ndash;                            </div>&ndash;&gt;-->
                    <!--                        &lt;!&ndash;                        </button>&ndash;&gt;-->
                    <!--                        <button *ngIf="data.edit && showActions && data?.invoice_status != 'Invoiced'" mat-menu-item-->
                    <!--                                (click)="saveRequirement(data)">-->
                    <!--                            <div class="moreActions">-->
                    <!--                                <i class="flaticon-save"></i>-->
                    <!--                                <span> Save Charge</span>-->
                    <!--                            </div>-->
                    <!--                        </button>-->
                    <!--                    </mat-menu>-->
                </mat-cell>
            </ng-container>
            <mat-header-row
                *matHeaderRowDef="chargeChildColumns ; sticky: true "></mat-header-row>
            <mat-row *matRowDef="let row; columns: chargeChildColumns;"></mat-row>
        </mat-table>
        <ng-container *ngIf="!reqirementChargesDataSource?.data?.length">
            <div class="noData" (mousemove)="onMouseMove($event)">
                <h1 #title>No Data Found</h1>
            </div>
        </ng-container>
        <!--        <mat-paginator [pageSizeOptions]="[5, 10, 25]" aria-label="Select page of users"-->
        <!--                       [pageSize]="10"-->
        <!--                       [length]="pageLength" (page)="pageChanged($event)"-->
        <!--                       #paginator></mat-paginator>-->
    </ng-container>
    <ng-container *ngIf="!hideAddCharge">
        <div fxLayout="column" class=" justify-content-start align-items-end gap-2 " style="z-index: 101">
            <div class="setTable " [ngClass]="'empty-repo-charge-table'"
                 [class.d-none]="chargesDataSource.data.length == 0">
                <mat-table [dataSource]="chargesDataSource" class="lightSleekTable">
                    <ng-container matColumnDef="charge_name">
                        <mat-header-cell *matHeaderCellDef>Charge</mat-header-cell>
                        <mat-cell *matCellDef="let data; let index = index" style="overflow: visible" class="p-r-15">
                            <div fxLayout="column" class="align-items-flex-start w-100">
                                <app-mat-auto-search [isEditable]="true"
                                                     [idField]="null"
                                                     [name]="'charge_head' + index"
                                                     [(ngModel)]="data.charge"
                                                     [listUrl]="chargeMaster_url+'charge_master/?search=::search::'"
                                                     [labelItemTemplate]="chargeSelectedItem"
                                                     [itemTemplate]="chargeItem"
                                                     class="w-100 bookingChargeAutoSearch">
                                </app-mat-auto-search>
                                <!--                                <mat-chip class="secondary-chip sleek-chip">{{ data.basis }}</mat-chip>-->
                            </div>
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                    </ng-container>
                    <ng-container matColumnDef="requirement">
                        <mat-header-cell *matHeaderCellDef>Req</mat-header-cell>
                        <mat-cell *matCellDef="let data; let index = index" style="overflow: visible" class="p-r-15">
                            <div fxLayout="column" class="align-items-flex-start w-100">
                                <app-mat-auto-search [isEditable]="data.charge?.uom?.dev_value != 'job'"
                                                     [idField]="null"
                                                     [name]="'requirement' + index"
                                                     [(ngModel)]="data.requirement"
                                                     [options]="quoteList?.requirements"
                                                     [labelItemTemplate]="requirementItemSelected"
                                                     [itemTemplate]="requirementItem"
                                                     class="w-100 bookingChargeAutoSearch">
                                </app-mat-auto-search>
                            </div>
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                    </ng-container>
                    <ng-container matColumnDef="rec_amount">
                        <mat-header-cell *matHeaderCellDef>Rec Amt/Qty</mat-header-cell>
                        <mat-cell *matCellDef="let data; let index = index" style="overflow: visible;" class="p-r-15">
                        <span>
                            <logzy-money-field [isEditable]="true" [(amount)]="data.rec_amount"
                                               [minValue]="0" (amountChange)="setRecTotal(data)"
                                               [maxValue]="999999999" [(currencyCode)]="data.rec_currency"
                                               class="bookingChargeMoneyField">
                            </logzy-money-field>
                        </span>
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                    </ng-container>
                    <ng-container matColumnDef="rec_total">
                        <mat-header-cell *matHeaderCellDef>Total (Rec)</mat-header-cell>
                        <mat-cell *matCellDef="let data; let index = index">
                            <span>{{ data.rec_total + ' ' + data.rec_currency }}</span>
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef="let data">
                        </mat-footer-cell>
                    </ng-container>
                    <ng-container matColumnDef="rec_remark">
                        <mat-header-cell *matHeaderCellDef>Remark (Rec)</mat-header-cell>
                        <mat-cell *matCellDef="let data; let index = index" class="p-r-15">

                            <app-text-field [isMultiline]="true" [isEditable]="true" [(ngModel)]="data.rec_remarks"
                                            class="w-100 bookingChargetextField"
                                            [name]="'rec_remarks'">
                            </app-text-field>

                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                        <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
                        <mat-cell *matCellDef="let data; let index = index">
                            <div class="Actions">
                                <i class="flaticon-add" (click)="addNewCharge()" [matTooltip]="'Add another Charge'"
                                ></i>
                                <i class="flaticon-delete" (click)="deleteRow(index)"
                                   [matTooltip]="'Delete Charge row'"></i>
                            </div>
                        </mat-cell>
                        <mat-footer-cell *matFooterCellDef="let data"></mat-footer-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumnsCharges ; sticky: true "></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumnsCharges;"
                             [hidden]="chargesDataSource.data.length == 0"></mat-row>
                </mat-table>
            </div>
        </div>
        <div class="btnb" *ngIf="chargesDataSource.data.length != 0" style="display: flex;
                                                                            justify-content: end;
                                                                            margin-top: 10px;">
            <button mat-raised-button (click)="saveCharges()" class="addBtn clickIt"
                    [disabled]="chargesDataSource.data.length == 0">
                    <span *ngIf="!disableSave">
                        Save Charges
                    </span>
                <div *ngIf="disableSave" class="p03">
                    <i class="flaticon-loading spin"></i>
                    <span>Saving ...</span>
                </div>
            </button>
        </div>
    </ng-container>
</div>

<ng-template #userItem let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item?.charge?.print_name }}
        </span>
        <span class="email">
            {{ item?.charge?.charge_code }}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItem let-item>
    {{ item?.charge?.print_name }}
</ng-template>

<ng-template #userItemPaid let-item let-index>
    <div fxFlex=" 100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item?.legal_name }}
        </span>
        <span class="email">{{ item?.address }}
        </span>
    </div>
</ng-template>

<ng-template #userSelectedItemPaid let-item>
    {{ item?.legal_name }}
</ng-template>

<ng-template #chargeItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item.charge_head }}
        </span>
        <span class="email">
            HSN Code: {{ item?.hsn_code?.code }}({{ item?.hsn_code?.max_tax_rate }}%)
        </span>
        <!-- <span class="email">
            Tax Rate:{{item?.hsn_code?.max_tax_rate}}%
        </span> -->
    </div>
</ng-template>

<ng-template #chargeSelectedItem let-item>
    {{ item.charge_head }}
</ng-template>

<ng-template #requirementItem let-item let-index>
    <div fxFlex="100" fxLayout="column" class="managerListShow">
        <span class="fullname">
            {{ item ? (item.quantity + '*' + item.container_size_type?.display) : '' }}
        </span>
    </div>
</ng-template>

<ng-template #requirementItemSelected let-item>
    {{ item.quantity + '*' + item.container_size_type?.display }}
</ng-template>
